import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { useStaticQuery, graphql, Link } from 'gatsby'
import StoreContext from '~/context/StoreContext'
// import cart from '../../img/cart-white.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../utils/fontawesome'
// import { Img } from '~/utils/styles'

const IOSWrap = styled.div`
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
`

const ProductGrid = (props) => {
  const { store: { checkout } } = useContext(StoreContext)
  const { allShopifyProduct } = useStaticQuery(
    graphql`
      query {
        allShopifyProduct(
          sort: {
            fields: [createdAt]
            order: DESC
          }

        ) {
          edges {
            node {
              id
              title
              description
              handle
              productType
              createdAt
              images {
                id
                originalSrc
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 910) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
              }
              variants {
                price
              }
            }
          }
        }
      }
    `
  )

  // const { data } = props
  const allArticles = allShopifyProduct.edges

  const emptyQuery = ''
  const [state, setState] = useState({
    filteredData: [],
    query: emptyQuery
  })

  const handleInputChange = event => {
    console.log(event.target.value)
    const query = event.target.value
    // const { data } = props

    const articles = allShopifyProduct.edges || []

    const filteredData = articles.filter(article => {
      const { description, title, productType } = article.node
      return (
        description.toLowerCase().includes(query.toLowerCase()) ||
        title.toLowerCase().includes(query.toLowerCase()) ||
        productType.toLowerCase().includes(query.toLowerCase())
      )
    })

    setState({
      query,
      filteredData
    })
  }

  const FilteredArticlesAmount = () => {
    if (filteredData.length >= 1) {
      return (
        <h4 className='has-text-centered subtitle is-4' style={{ color: '#333' }}>{articles.length} Artikel gefunden!</h4>
      )
    }
  }

  const NoFilteredArticles = () => {
    if (articles.length < 1) {
      return (
        <div className='hero is-medium'>
          <div className='hero-body'>
            <h4 className='has-text-centered subtitle is-4' style={{ color: '#333' }}>Keine Artikel gefunden!</h4>
          </div>
        </div>
      )
    }
  }

  const { filteredData, query } = state
  const hasSearchResults = filteredData && query !== emptyQuery
  const articles = hasSearchResults ? filteredData : allArticles

  const getPrice = price => Intl.NumberFormat(undefined, {
    currency: checkout.currencyCode ? checkout.currencyCode : 'EUR',
    minimumFractionDigits: 2,
    style: 'currency'
  }).format(parseFloat(price ? price : 0))

  return (
    <>
      <section id='produkte' style={{ background: '#fff', position: 'relative' }}>
        <Banner id='search'>
          {/*
          <label className='has-text-primary'>Artikelsuche&nbsp;</label>
          */}

          <div class='field has-addons has-addons-centered'>
            <div class='control is-expanded' style={{ maxWidth: '250px' }}>

              <input
                className='input is-primary' style={{ height: '2.8rem', borderRadius: '0px' }}
                type='text'
                name='search'
                onChange={handleInputChange}
                id='suche'
                required={true}
                placeholder='Artikelsuche'
              />
            </div>
            <div class='control'>
              <button className='button is-medium is-primary' role='button' aria-label='search'>
                <FontAwesomeIcon icon='search' />
              </button>
            </div>
          </div>
        </Banner>
        <IOSWrap>
          <div className='columns is-multiline is-centered is-mobile is-marginless is-paddingless'>
            <div className='column is-12'>
              {FilteredArticlesAmount()}
            </div>
            {articles
              ? articles.map(({ node: { id, handle, title, description, images: [firstImage], variants: [firstVariant] } }) => (
                <div className='column is-3' key={id} style={{ minWidth: '180px', margin: '0 auto' }}>
                  <Product>
                    <Link to={`/product/${handle}/`}>
                      {firstImage && firstImage.localFile &&
                        (<Zoom>
                          <Image
                            fluid={firstImage.localFile.childImageSharp.fluid}
                            alt={handle}
                          />
                        </Zoom>
                        )}

                      <ProductInfo>
                        <Title className='title is-5 has-text-primary'>{title}</Title>
                        <Description>{description}</Description>
                        <PriceTag className='has-text-primary'>{getPrice(firstVariant.price)}</PriceTag>
                      </ProductInfo>
                      {/*
                      <span className='detailsAndBuy'>
                        <Link to={`/product/${handle}/`} className='button is-primary is-fullwidth'>
                          Details & Kaufen&nbsp;<img src={cart} alt='Warenkorb' style={{ width: '25px' }} />
                        </Link>
                      </span>
                      */}
                    </Link>
                  </Product>
                </div>
              ))
              : <p>Keine Produkte gefunden! Versuche die Seite neu zu laden!</p>}

          </div>
        </IOSWrap>
        {NoFilteredArticles()}
      </section>
    </>
  )
}

export default ProductGrid

const Banner = styled.div`
  position: sticky;
  top: 77px;
  left: 0px;
  margin-bottom: 2rem;
  z-index: 1;
  width: 90%;
  margin: 0 auto;
  background: #161c27;
  // background: -moz-linear-gradient(120deg, rgba(252,148,57,1) 0%, rgba(116,56,94,1) 100%);
  // background: -webkit-linear-gradient(120deg, rgba(213,97,78,1 ) 0%,rgba(116,56,94,1) 100%);
  // background: linear-gradient(120deg, rgba(240,225,2,1) 0%,rgba(213,97,78,1) 100%);
  padding: 10px;
  font-size: 1.5rem;
  // color: #fff;
  text-align: center;
  font-weight: 900;
  text-transform: uppercase;
`

const Product = styled.div`
  position: relative;
  display: flex;
  min-height: 100%;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0,0,0,.1);
  @media(min-width: 779px){
    .detailsAndBuy{
      display: none;
      width: 100%;
      position: absolute;
      bottom: 0;
      right: 0;
      border: none;
      font-size: 1.4rem;
      transform: translate(100%, 100%);
      transition: all 0.2s linear;
    }
    &:hover{
      .detailsAndBuy{
        display: inline-block;
        transform: translate(0,0);

      }
    }
  }
  @media(max-width: 779px){
    .detailsAndBuy{
      display: inline-block;
      width: 100%;
      position: absolute;
      bottom: 0;
      right: 0;
      border: none;
      font-size: 1.4rem;
    }
  }
`

const ProductInfo = styled.div`
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  // padding-bottom: 40px;

`

const Title = styled.h1`
  font-family: 'Montserrat';
  text-transform: uppercase;
  text-align: left;
  hyphens: auto;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
`

const Description = styled.p`
  font-weight: 300;
  font-size: 1rem;
  margin-top: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: auto;
  height: 50px;
  color: #333333;
`

const PriceTag = styled.span`
  font-weight: 900;
  font-size: 1rem;
  text-align: center;
  margin-top: 15px;
  // :before {
  //   content: '- '
  // }
`

const Zoom = styled.div`
  overflow: hidden;
  height: 200px;
`

const Image = styled(Img)`
  max-width: 100%;
  height: 200px;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.15);
  transition: transform .5s ease;
  &:hover{
    transform: scale(1.1);
  }
`
